import { IPresenceAction } from '@engoo/realtime-protocol/presence';
import { presenceReducer, PresenceState } from 'app/models/presence/reducer';
import { tFunctionType } from 'app/services/localization';
import { LWWDocumentManager, IActionHandler } from 'app/services/rtc/sync/documentmanagers/lww';
import { IDocumentManagerState } from 'app/containers/rtc/DocumentProvider/useDocumentManager';
import { IDocumentManagerFactory } from 'app/services/rtc/sync/DocumentSpec';

type PresenceManager = LWWDocumentManager<PresenceState, IPresenceAction>;

export type PresenceDocumentManagerState = IDocumentManagerState<PresenceState, PresenceManager>;

const managerType: IDocumentManagerFactory<
  PresenceState,
  IPresenceAction,
  IActionHandler<PresenceState, IPresenceAction>,
  PresenceManager
> = LWWDocumentManager;

const actionHandler: IActionHandler<PresenceState, IPresenceAction> = { apply: presenceReducer };

export const PresenceDocumentSpec = {
  managerType,
  actionHandler,
  initialState:  presenceReducer(),
  name: (t: tFunctionType) => t('rtc.features.presence.name'),
};
